import React, { Component, Fragment, version } from "react";
import { curdActions } from "../../../reduxCURD/actions";
import CustomForm from "../../../libraries/form";
import { CRUDFunction } from "../../../reduxCURD/container";
import {
  BridgeFields,
  WOGPSFields,
  MaintenanceSchema,
  fieldsToApplyMethod,
  maintenanceSchemaMPFields,
  maintenanceSchemaMarkerFields,
  TIMPSAfeField,
  TIMPSChargeCodeField,
} from "./workOrderSchema";
import _ from "lodash";
import { treeToPropertiesObject } from "../../../utils/treeData";
import { maintenanceFormMethod } from "./maintenanceFormMethods";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import { Col } from "reactstrap";
import { maintenanceTranslateInterface, maintenanceEditLoadMethod } from "./maintenanceTranslator";
import { DocumentImageSection } from "./DocumentImageSection";
import ConfirmationDialog from "../../../libraries/ConfirmationDialog";
import { versionInfo } from "../../MainPage/VersionInfo";
import { languageService } from "../../../Language/language.service";
import { applyMethodToObjectProps } from "../../../utils/ApplyMethodOnObjectProps";
import { ToastService } from "../../../utils/toastify";

class AddMaintenanceV2 extends Component {
  constructor(props) {
    super(props);
    this.defaultState = maintenanceFormMethod.loadDefaultState(props);
    this.state = {
      maintenanceFields: { ...this.defaultState },
      showModel: false,
      assetDataLoaded: false,
      formCustomSectionComps: [],
      showImageSlider: false,
      showImageGallery: false,
      showDocuments: false,
      selectedImageIndex: 0,
      imageList: [],
      documentList: [],
      confirmationDialog: null,
    };

    this.maintenanceSchema = this.getWOSchema();

    this.onSubmit = this.onSubmit.bind(this);
    this.getAssetsOnLineChange = this.getAssetsOnLineChange.bind(this);
    this.setMpMarkerSectionOnAssetChange = this.setMpMarkerSectionOnAssetChange.bind(this);
    this.addMaintenanceStateHandler = this.addMaintenanceStateHandler.bind(this);
    this.addSelectedImage = this.addSelectedImage.bind(this);
    this.addDocumentHandle = this.addDocumentHandle.bind(this);
    this.addSelectedDocument = this.addSelectedDocument.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
    this.openConfirmationDialog = this.openConfirmationDialog.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
  }
  componentDidMount() {
    this.props.getAsset("/getAssetTreeAndTypes");
    // this.loadMaintenanceFormModel();
  }
  componentDidUpdate(prevProps, prevState) {
    // if (this.props.modal !== this.state.showModel) {
    //   this.loadMaintenanceFormModel(this.state.locationObj, this.state.assetTypes, this.state.assetsTrees);
    // }
    if (this.props.priorityList !== prevProps.priorityList) {
      this.setState({
        maintenanceFields: {
          ...this.state.maintenanceFields,
          ...maintenanceFormMethod.loadDefaultState(this.props),
        },
      });
    }
    if (this.props.assetActionType === "ASSET_READ_SUCCESS" && prevProps.assetActionType !== this.props.assetActionType) {
      let locationObj = [];
      if (this.props.asset) {
        const assetsTrees = this.props.asset.assetTree;
        const assetTypes = this.props.asset.assetsTypes;
        const allAssets = treeToPropertiesObject(assetsTrees);
        if (allAssets.length) {
          locationObj = allAssets.filter((item) => item && item.location === true && item.plannable == true);
          // let allAssetsExcludingLocations = allAssets.filter((item) => item && item.location === false);
          let locAssetsMap = new Map();
          locationObj.forEach((loc) => {
            let assets = maintenanceFormMethod.getAssetsListForLineId(loc._id, assetsTrees);
            locAssetsMap.set(loc._id, assets);
          });
          if (locationObj.length > 0) {
            this.setState({
              assets: allAssets,
              lineAssets: locAssetsMap,
              locationObj: locationObj,
              assetTypes: assetTypes,
              assetsTree: assetsTrees,
              assetDataLoaded: true,
            });
            this.props.modal && this.loadMaintenanceFormModel(locationObj, allAssets, assetsTrees, assetTypes, locAssetsMap);
          }
        }
      }
    }
    if (this.state.assetDataLoaded && this.props.modal && prevProps.modal !== this.props.modal) {
      this.loadMaintenanceFormModel(
        this.state.locationObj,
        this.state.assets,
        this.state.assetsTree,
        this.state.assetTypes,
        this.state.lineAssets,
      );
    }
  }

  closeConfirmationDialog() {
    this.setState({
      confirmationDialog: null,
    });
  }
  getWOSchema() {
    let SchemaWithUpdatedField = applyMethodToObjectProps(MaintenanceSchema, fieldsToApplyMethod, languageService);
    let tempWO = _.cloneDeep(SchemaWithUpdatedField);
    const { selectedMaintenance } = this.props;
    const currAppType = versionInfo.getApplicationType();
    const bridgeWorkOrder = versionInfo.getFeatureset("bridgeWorkOrder");
    let isAppIssue =
      selectedMaintenance && (selectedMaintenance.sourceType === "app-issue" || selectedMaintenance.sourceType === "manual-app-workorder");
    if (currAppType === "ReVAMP") {
      let fields = tempWO.sections[1].fields;
      tempWO.sections[1].fields = maintenanceFormMethod.updateMaintenanceTypeFieldForRevamp(fields);
    }
    if (currAppType === "TIMPS" || currAppType === "SITE") {
      WOGPSFields.forEach((TimpsSection) => {
        const timpsIndex = tempWO.sections.findIndex((section) => section.id === TimpsSection.sectionID);
        let fieldsLength = tempWO.sections[timpsIndex].fields.length;
        if (timpsIndex !== -1) {
          tempWO.sections[timpsIndex].fields.splice(TimpsSection.pushIndex(fieldsLength), 0, ...TimpsSection.fields);
        }
      });

      if (versionInfo.isChargeCodeField()) {
        if (!isAppIssue) {
          TIMPSChargeCodeField.forEach((TimpsSection) => {
            const timpsIndex = tempWO.sections.findIndex((section) => section.id === TimpsSection.sectionID);
            let fieldsLength = tempWO.sections[timpsIndex].fields.length;
            if (timpsIndex !== -1) {
              tempWO.sections[timpsIndex].fields.splice(TimpsSection.pushIndex(fieldsLength), 0, ...TimpsSection.fields);
            }
          });
        }
      } else {
        TIMPSAfeField.forEach((TimpsSection) => {
          const timpsIndex = tempWO.sections.findIndex((section) => section.id === TimpsSection.sectionID);
          let fieldsLength = tempWO.sections[timpsIndex].fields.length;
          if (timpsIndex !== -1) {
            tempWO.sections[timpsIndex].fields.splice(TimpsSection.pushIndex(fieldsLength), 0, ...TimpsSection.fields);
          }
        });
      }

      if (bridgeWorkOrder && bridgeWorkOrder.value === true) {
        const bridgeIndex = tempWO.sections.findIndex((section) => section.id === BridgeFields.sectionID);
        if (bridgeIndex !== -1) {
          tempWO.sections[bridgeIndex].fields.push(...BridgeFields.fields);
        }
      }
    }

    return tempWO;
  }

  loadMaintenanceFormModel(locations, assets, assetsTree, assetTypes, locAssetsMap) {
    // modal state updated, process usual thing.
    let addEditModeState = maintenanceFormMethod.loadAddEditModelState(
      this.props.modal,
      this.props.modalState,
      this.props.selectedMaintenance,
    );
    const compileResult = this.compileMaintenanceSchema(
      {
        addEditModeState: addEditModeState,
        modalState: this.props.modalState,
        selectedMaintenance: this.props.selectedMaintenance,
      },
      { locations: locations, assets: assets, assetsTree: assetsTree, assetTypes: assetTypes, locAssetsMap: locAssetsMap },
    );
    this.maintenanceSchema = compileResult.schema;
    this.setState({
      showModel: this.props.modal,
      currState: addEditModeState,
      maintenanceFields: compileResult.maintenanceFields,
      ...compileResult.imageDocState,
    });
  }
  compileMaintenanceSchema(
    { addEditModeState, modalState, selectedMaintenance },
    { locations, assets, assetsTree, assetTypes, locAssetsMap },
  ) {
    let maintenanceFields = { ...maintenanceFormMethod.loadDefaultState(this.props) };
    let maintenanceSchema = this.getWOSchema();
    let changeData = {};
    let imageDocState = { imageList: [], documentList: [] };

    // load options
    let mTypeOptions = maintenanceFormMethod.loadMaintenanceType(this.props.maintenanceTypes);
    let pCodeOptions = maintenanceFormMethod.loadChargeCodes(this.props.chargeCodes);
    let locationOptions = maintenanceFormMethod.loadLocationOptions(locations);
    let priorityListOptions = maintenanceFormMethod.loadPriorityList(this.props.priorityList);
    if (mTypeOptions[0]) changeData.maintenanceType = { selectOptions: mTypeOptions };
    if (pCodeOptions[0]) changeData.chargeCode = { selectOptions: pCodeOptions };
    if (locationOptions[0]) changeData.lineId = { selectOptions: locationOptions };
    if (priorityListOptions[0]) changeData.priority = { selectOptions: priorityListOptions };
    if (modalState === "Add" && maintenanceFields.maintenanceType === "other" && mTypeOptions[0])
      maintenanceFields.maintenanceType = mTypeOptions[0].val;

    if (modalState === "Add" && maintenanceFields.chargeCode === "other" && pCodeOptions[0])
      maintenanceFields.chargeCode = pCodeOptions[0].val;

    if (modalState === "Edit") {
      maintenanceFields = maintenanceEditLoadMethod.loadEditMFields(selectedMaintenance);
      imageDocState = maintenanceEditLoadMethod.loadEditImageDocument(selectedMaintenance);
    }
    return { maintenanceFields: maintenanceFields, schema: updateShortSchema(maintenanceSchema, changeData), imageDocState: imageDocState };
  }

  getAssetsOnLineChange(lineId, reload) {
    let lineAssets = this.state.lineAssets && this.state.lineAssets.get(lineId);
    if (!reload)
      this.setState({
        formCustomSectionComps: maintenanceFormMethod.setCustomSectionFormFields(this.state.formCustomSectionComps, null),
      });

    let assetOptions = maintenanceFormMethod.loadAssetOptions(lineAssets);
    return assetOptions;
  }

  setMpMarkerSectionOnAssetChange(assetId) {
    let schemaFields = [];
    const { currState } = this.state;
    let resObj = null;
    let WO = this.getWOSchema();
    if (!versionInfo.isReVAMP()) {
      schemaFields = maintenanceFormMethod.unHideFDOTBasedOnFormState(WO.sections[2].fields, currState);
      resObj = maintenanceFormMethod.getMpMarkerSectionOnAssetChange(assetId, this.state.assets, this.state.assetTypes);
      if (resObj && resObj.schemaFields) schemaFields = [...resObj.schemaFields, ...schemaFields];
    } else {
      schemaFields = [...WO.sections[2].fields];
    }
    this.setState({
      formCustomSectionComps: maintenanceFormMethod.setCustomSectionFormFields(
        this.state.formCustomSectionComps,
        resObj && resObj.customComp,
      ),
    });

    return schemaFields;
  }
  setUpFDOTFieldsOnChange(value) {
    console.log(value);
  }
  onSubmit({ fields }) {
    // process fields

    // return;
    const handleMaintenanceSave = () => {
      let m = maintenanceTranslateInterface.addNewMaintenance(
        fields,
        { documentList: this.state.documentList, imgList: this.state.imageList },
        { locations: this.state.locationObj, assets: this.state.assets },
      );
      if (m && m.closedDate) {
        const title = languageService("Confirm MR To Historical");
        const message = languageService(
          "This MR has been marked as historical. Saving now will close this MR and cannot be changed later.",
        );
        const displayAddInfo = languageService("Do you want to proceed ?");
        this.openConfirmationDialog(title, message, "Historical", displayAddInfo, this.handleConfirmation, {
          maintenance: m,
          modalState: this.props.modalState,
        });
      } else {
        this.props.addMaintenanceHandler(m, this.props.modalState);
      }
    };

    let isValidLatLong = maintenanceTranslateInterface.isLikelyRealCoordinates(fields);
    if (!isValidLatLong) {
      ToastService.Error("Invalid GPS Coordinates", " ");
      return;
    } else handleMaintenanceSave();

    // console.log("newM", m);
  }

  handleConfirmation(action, additionalInfo) {
    const key = {
      Historical: () => this.props.addMaintenanceHandler(additionalInfo.maintenance, additionalInfo.modalState),
    };

    key[action]();
    this.closeConfirmationDialog();
  }
  openConfirmationDialog(title, message, action, displayAddInfo, confirmCallback, additionalInfo) {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title={title}
          body={
            <Fragment>
              <div>
                <strong>{languageService("Note")}:</strong>
                {`${message}`}
              </div>
              {displayAddInfo}
            </Fragment>
          }
          action={action}
          additionalInfo={additionalInfo}
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={confirmCallback}
        />
      ),
    });
  }

  addMaintenanceStateHandler = (newState) => this.setState({ ...newState });

  addSelectedImage = (imgName) => {
    if (imgName) {
      const { imageList } = this.state;
      this.setState({
        imageList: [...imageList, imgName],
        showImageGallery: false,
        showImageSlider: false,
      });
    } else {
      this.setState({
        showImageGallery: false,
        showImageSlider: false,
      });
    }
  };
  addDocumentHandle = (newState) => this.setState({ ...newState });

  deleteDocumentHandle = (docName, index) => {
    this.setState(({ documentList }) => ({ documentList: documentList.filter((doc, i) => i !== index) }));
  };
  deleteImageHandle = (imgName, index) => {
    this.setState(({ imageList }) => ({ imageList: imageList.filter((doc, i) => i !== index) }));
  };

  addSelectedDocument = (docName) => {
    if (docName) {
      this.setState(({ documentList }) => ({ documentList: [...documentList, docName], showDocuments: false }));
    } else {
      this.setState({
        showDocuments: false,
      });
    }
  };
  render() {
    return (
      <React.Fragment>
        {this.state.confirmationDialog}
        {this.props.modal && this.state.showModel && (
          <CustomForm
            mode="dialog"
            fieldsData={this.state.maintenanceFields}
            currState={this.state.currState}
            formSchema={this.maintenanceSchema}
            closeDialog={this.props.toggle}
            parentRef={{
              onSubmit: this.onSubmit,
              getAssetsOnLineChange: this.getAssetsOnLineChange,
              setMpMarkerSectionOnAssetChange: this.setMpMarkerSectionOnAssetChange,
              setUpFDOTFieldsOnChange: this.setUpFDOTFieldsOnChange,
            }}
            formCustomSectionComps={[
              ...this.state.formCustomSectionComps,
              ...DocumentImageSection.loadDocumentImageArea(
                {
                  documentList: this.state.documentList,
                  imageList: this.state.imageList,
                  showImageSlider: this.state.showImageSlider,
                  showImageGallery: this.state.showImageGallery,
                  showDocuments: this.state.showDocuments,
                  selectedImageIndex: this.state.selectedImageIndex,
                },
                {
                  addMaintenanceStateHandler: this.addMaintenanceStateHandler, // methods
                  addDocumentHandle: this.addDocumentHandle,
                  addSelectedDocument: this.addSelectedDocument,
                  addSelectedImage: this.addSelectedImage,
                  deleteDocumentHandle: this.deleteDocumentHandle,
                  deleteImageHandle: this.deleteImageHandle,
                },
              ),
            ]}
          />
        )}
      </React.Fragment>
    );
  }
}

const getAsset = curdActions.getAsset;

let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: { getAsset },
};

let variables = {
  assetReducer: { asset: [], assetTypes: [] },
};

const AddMaintenanceV2Container = CRUDFunction(AddMaintenanceV2, "addMaintenanceV2", actionOptions, variables, ["assetReducer"]);
export default AddMaintenanceV2Container;

export const genericMpMarkerField = (id, label, value, disabled) => {
  return (
    <Col md={12}>
      <div className={"field"}>
        <div className="field-style">
          <label className={"show-label-small"}>{label}</label>
          <input id={id} name={id} value={value} disabled={disabled} className="input-style" title="" />
        </div>
      </div>
    </Col>
  );
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/AddMaintenanceV2/AddMaintenanceV2.jsx